import { useQuery } from '@tanstack/react-query';
import { Device } from '@ixicare/resources';
import React from 'react';
import { useStores } from '~store/utils';

export function useLowBatteryDevices() {
  const { sites } = useStores();
  const siteUuid = sites.selectedSite?.uuid;
  const { data, refetch } = useQuery({
    queryKey: ['low-battery-devices', siteUuid],
    queryFn: () =>
      Device.getLowBatteryDevices({
        site: siteUuid!,
        threshold: 26,
      }),
    enabled: !!siteUuid,
  });
  const isFocused = true;
  React.useEffect(() => {
    if (isFocused) {
      refetch();
    }
  }, [isFocused]);
  return data;
}
